import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigBrochureService {
  private API_BROCHURE_URL = environment.API_URL + "api/brochure";
  constructor(private http: HttpClient) { }

  getAllBrochures(){
    return this.http.get(this.API_BROCHURE_URL + "/getall")
  }

  createBrochureConfig(data){
    return this.http.post(this.API_BROCHURE_URL + "/create", data)
  }

  editBrochureConfig(data){
    return this.http.post(this.API_BROCHURE_URL + "/edit", data)
  }

  deleteBrochureConfig(id){
    return this.http.post(this.API_BROCHURE_URL + "/delete", id)
  }
}
